import { render, staticRenderFns } from "./change-password-form.vue?vue&type=template&id=196af4bf"
import script from "./change-password-form.vue?vue&type=script&lang=js"
export * from "./change-password-form.vue?vue&type=script&lang=js"
import style0 from "./change-password-form.vue?vue&type=style&index=0&id=196af4bf&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports